import { Company, User } from 'src/constants';
import { useGetClientUsersQuery } from 'src/services/api';
import { useGetCompaniesQuery } from 'src/services/api/companiesApi';

// default global constants to avoid returning a new array reference
// in every re-rerender that uses this hook.
const defaultClients: User[] = [];
const defaultCompanies: Company[] = [];

export const useFetchClientAccessData = (skip: boolean) => {
  const { isFetching: clientsLoading, data: clients } = useGetClientUsersQuery(
    { ignoreAccess: true },
    { skip },
  );

  const { isFetching: companiesLoading, data: companies } =
    useGetCompaniesQuery({ ignoreAccess: true }, { skip });

  return {
    isLoading: clientsLoading || companiesLoading,
    clients: clients || defaultClients,
    companies: companies || defaultCompanies,
  };
};
